import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from './primeng/primeng.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SummarySectionComponent } from './components/summary-section/summary-section.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    SummarySectionComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule
  ],
  exports: [
    PrimengModule,
    TranslateModule,
    BreadcrumbComponent,
    SummarySectionComponent,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class SharedModule { }
